export type CategoryConfig = {
  key: string;
  emoji?: string;
  imageSource?: string;
  imageAlt?: string;
};

export const categoryConfigurations: CategoryConfig[] = [
  { key: 'allPurchases', emoji: '⭐' },
  { key: 'allPurchases.mobileWallet', emoji: '📱' },
  { key: 'allPurchases.mobileWallet.applePay', emoji: '🍎' },
  { key: 'allForeignPurchases', emoji: '🌍' },
  { key: 'dining', emoji: '🍽️' },
  { key: 'gas', emoji: '⛽' },
  { key: 'gas.cenex', emoji: '⛽' },
  { key: 'gas.costco', emoji: '⛽' },
  { key: 'gas.evCharging', emoji: '🔌' },
  { key: 'medicalExpenses', emoji: '🏥' },
  { key: 'grocery', emoji: '🛒' },
  { key: 'streaming', emoji: '📺' },
  { key: 'drugstore', emoji: '💊' },
  { key: 'dining.takeoutDelivery', emoji: '🥡' },
  { key: 'officeSupplies', emoji: '📎' },
  { key: 'internetCablePhone', emoji: '📡' },
  { key: 'fitness', emoji: '🏃' },
  { key: 'travel', emoji: '🏖️' },
  { key: 'travel.airline', emoji: '✈️' },
  { key: 'travel.hotel', emoji: '🏨' },
  { key: 'travel.travelportal', emoji: '🌐' },
  { key: 'travel.rideshare', emoji: '🚗' },
  { key: 'travel.cruise', emoji: '🚢' },
  { key: 'travel.cruise.royalCaribbean', emoji: '🚢' },
  { key: 'travel.cruise.carnival', emoji: '🚢' },
  { key: 'travel.cruise.norwegian', emoji: '🚢' },
  {
    key: 'travel.airline.united',
    emoji: '✈️',
    imageSource: '/programs/united.png',
    imageAlt: 'United Airlines',
  },
  {
    key: 'travel.airline.delta',
    emoji: '✈️',
    imageSource: '/programs/delta.jpeg',
    imageAlt: 'Delta Airlines',
  },
  {
    key: 'travel.airline.american',
    emoji: '✈️',
    imageSource: '/programs/aa.webp',
    imageAlt: 'American Airlines',
  },
  {
    key: 'travel.airline.southwest',
    emoji: '✈️',
    imageSource: '/programs/southwest.jpeg',
    imageAlt: 'Southwest Airlines',
  },
  {
    key: 'travel.airline.alaska',
    emoji: '✈️',
    imageSource: '/programs/alaska.jpeg',
    imageAlt: 'Alaska Airlines',
  },
  {
    key: 'travel.airline.hawaiian',
    emoji: '✈️',
    imageSource: '/programs/hawaiian.jpeg',
    imageAlt: 'Hawaiian Airlines',
  },
  {
    key: 'travel.airline.frontier',
    emoji: '✈️',
    imageSource: '/programs/frontier.jpeg',
    imageAlt: 'Frontier Airlines',
  },
  { key: 'travel.hotel.general', emoji: '🏨' },
  { key: 'travel.transit', emoji: '🚆' },
  { key: 'travel.rentalCar', emoji: '🚗' },
  { key: 'homeImprovement', emoji: '🏠' },
  { key: 'wholesaleClub', emoji: '🛒' },
  // Parent categories for fallbacks
  { key: 'selfCare', emoji: '💅' },
  { key: 'selfCare.cosmeticBarberHairSalons', emoji: '💇' },
  { key: 'homeFurnishings', emoji: '🛋️' },
  { key: 'homeFurnishings.ikea', emoji: '🛋️' },
  { key: 'homeFurnishings.potteryBarn', emoji: '🛋️' },
  { key: 'homeFurnishings.williamsSonoma', emoji: '🛋️' },
  { key: 'homeFurnishings.restorationHardware', emoji: '🛋️' },
  { key: 'homeFurnishings.crateAndBarrel', emoji: '🛋️' },
  { key: 'electronics', emoji: '📱' },
  { key: 'electronics.apple', emoji: '📱' },
  { key: 'electronics.bestBuy', emoji: '🛍️' },
  { key: 'telecommunications', emoji: '📞' },
  { key: 'telecommunications.verizon', emoji: '📞' },
  { key: 'entertainment', emoji: '🎭' },
  { key: 'entertainment.disneyPlusHuluEspn', emoji: '📺' },
  { key: 'thriftStores', emoji: '👔' },
  { key: 'rent', emoji: '🏠' },
  { key: 'housing', emoji: '🏠' },
  { key: 'petPurchases', emoji: '🐕' },
  { key: 'petPurchases.chewy', emoji: '🐕' },
  { key: 'onlineShopping', emoji: '🛍️' },
  { key: 'onlineShopping.paypal', emoji: '💳' },
  { key: 'onlineShopping.amazon', emoji: '📦' },
  { key: 'onlineShopping.wayfair', emoji: '📦' },
  { key: 'onlineShopping.gapInc', emoji: '👔' },
  { key: 'departmentStores', emoji: '🏬' },
  { key: 'departmentStores.macys', emoji: '📦' },
  { key: 'departmentStores.nordstrom', emoji: '📦' },
  { key: 'departmentStores.kohls', emoji: '📦' },
  { key: 'departmentStores.dillards', emoji: '📦' },
  { key: 'sportsEquipment', emoji: '🏀' },
  { key: 'sportsEquipment.llBean', emoji: '🏀' },
  { key: 'sportsEquipment.reiCoop', emoji: '🏔️' },
  { key: 'sportingGoods.bassProAndCabelas', emoji: '🎣' },
  { key: 'recreationLeisure', emoji: '🎯' },
  { key: 'craftsHobbies', emoji: '🎨' },
  { key: 'gardeningFloral', emoji: '🌱' },
  { key: 'bookstores', emoji: '📚' },
  { key: 'billsAndUtilities', emoji: '💡' },
  { key: 'phonePlans', emoji: '📱' },
  { key: 'computerServices', emoji: '💻' },
  { key: 'businessConsultingServices', emoji: '💼' },
  { key: 'onlineAdvertising', emoji: '📢' },
  { key: 'shipping', emoji: '📦' },
  { key: 'charity', emoji: '❤️' },
  { key: 'rotating_quarterly_rewards', emoji: '🔄' },
  { key: 'automotive', emoji: '🔧' },
  { key: 'capitalVacations', emoji: '🏖️' },
  { key: 'rci', emoji: '🏖️' },
  // Store-specific items get box emoji
  { key: 'gas.cenex', emoji: '📦' },
  { key: 'drugstore.cvs', emoji: '📦' },
  { key: 'drugstore.walgreens', emoji: '📦' },
  { key: 'homeImprovement.aceHardware', emoji: '📦' },
  { key: 'homeImprovement.lowes', emoji: '📦' },
  { key: 'homeImprovement.homeDepot', emoji: '📦' },
  { key: 'homeImprovement.menards', emoji: '📦' },
  { key: 'electronics.apple', emoji: '📦' },
  { key: 'electronics.bestBuy', emoji: '📦' },
  { key: 'petPurchases.chewy', emoji: '📦' },
  { key: 'onlineShopping.amazon', emoji: '📦' },
  { key: 'onlineShopping.wayfair', emoji: '📦' },
  { key: 'onlineShopping.gapInc', emoji: '📦' },
  { key: 'paperSource', emoji: '📦' },
  { key: 'departmentStores.macys', emoji: '📦' },
  { key: 'departmentStores.nordstrom', emoji: '📦' },
  { key: 'departmentStores.kohls', emoji: '📦' },
  { key: 'departmentStores.dillards', emoji: '📦' },
  // Services use direct parent emoji
  { key: 'dining.takeoutDelivery.ubereats', emoji: '🥡' },
  { key: 'dining.takeoutDelivery.doordash', emoji: '🥡' },
  { key: 'travel.rideshare.uber', emoji: '🚗' },
  { key: 'travel.rideshare.lyft', emoji: '🚗' },
  { key: 'streaming.disneyplus', emoji: '📺' },

  // Airline-specific categories
  { key: 'alaska_airlines', emoji: '✈️' },
  { key: 'hawaiian_airlines', emoji: '✈️' },
  { key: 'foreignTransactions', emoji: '🌍' },
  { key: 'foreign_transactions', emoji: '🌍' },
];
